<template>
  <v-card
    flat
    cols="12"
    md="12"
    sm="12"
    width="100%"
  >
    <v-tabs
      v-show="!hideTabLabel"
      v-model="tab"
      hide-slider
      class="tabs"
      :showArrows="false"
      @change="onTabChange"
    >
      <v-tab
        v-for="(tabItem, index) in tabs"
        active-class="active-tab"
        :key="index"
        :class="{
          tab: true,
          'level-1': level === 1,
          'level-2': level === 2,
          'level-2-as-1': level === 2 && level1Hidden
        }"
      >
        {{ tabItem.label }}
      </v-tab>
    </v-tabs>

    <v-divider
      v-if="(level === 1 && !hideTabLabel) || (level === 2 && level1Hidden)"
      :class="{ 'divider': true, 'level-1-hidden': level === 2 && level1Hidden }"
    />

    <v-tabs-items
      v-model="tab"
      :touchless="true"
    >
      <v-tab-item
        v-for="(tabItem, index) in tabs"
        :key="index"
        :transition="false"
        :reverse-transition="false"
      >
        <v-card flat>
          <component
            :key="index"
            :is="tabItem.section"
            :tab-lv1-index="level === 1 ? index : tabLv1Index"
            :tab-lv2-index="level === 2 ? index : undefined"
            :tabs-lv1-count="level === 1 ? tabs?.length : tabsLv1Count ?? 1"
          />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  inject: ['setActiveTabId'],
  props: ['tabs', 'level', 'tabLv1Index', 'tabsLv1Count'],
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    hideTabLabel() {
      return this.tabs.length < 2;
    },
    level1Hidden() {
      return this.tabsLv1Count != undefined && this.tabsLv1Count < 2;
    },
  },
  methods: {
    onTabChange(tab) {
      const tabLv1 = this.level === 1 ? tab : this.tabLv1Index;
      const tabLv2 = this.level === 2 ? tab : undefined;
      this.setActiveTabId?.(tabLv1, tabLv2);
    },
  },
};
</script>

<style lang="scss" scoped>
$tabs-splitter-color: #e5f0f5;
$active-tab-background-color: #b0d35e;
$active-tab-level-2-background-color: #d8d8d8;
$divider-color: #d8d8d8;
$divider-color-level-1-hidden: #b0d35e;

.tab {
  height: 48px;
  letter-spacing: 0.025em;
  line-height: normal;
  position: relative;
  text-transform: none;

  &.level-1 {
    margin-right: 5px;
  }

  &.level-1::after,
  &.level-2.level-2-as-1::after {
    content: "";
    background: $tabs-splitter-color;
    height: 100%;
    position: absolute;
    right: -5px;
    top: 0;
    width: 5px;
  }
}

.active-tab {
  &.level-1,
  &.level-2.level-2-as-1 {
    background-color: $active-tab-background-color;
    border-radius: 0;
    font-weight: 600;

    &:first-of-type {
      border-radius: 8px 0 0 0;
    }
  }

  &.level-2 {
    background-color: $active-tab-level-2-background-color;
    border-radius: 0 0 8px 8px;
  }
}

.divider {
  border-color: $divider-color;
  border-width: 2px 0 0 0 !important;

  &.level-1-hidden {
    border-color: $divider-color-level-1-hidden !important;
  }
}
</style>
